var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "exit",
    d: "M8.9,2A6.4,6.4,0,0,0,2.5,8.4v8H19.437l-3.669-3.669a1.6,1.6,0,0,1,2.263-2.263l6.4,6.4.012.012A1.595,1.595,0,0,1,24.9,18V18a1.6,1.6,0,0,1-.458,1.116l-.012.012-6.4,6.4a1.6,1.6,0,1,1-2.263-2.263L19.437,19.6H2.5v8A6.4,6.4,0,0,0,8.9,34H28.1a6.4,6.4,0,0,0,6.4-6.4V8.4A6.4,6.4,0,0,0,28.1,2Z",
    transform: "translate(-2.5 -2)",
    fill: "#df9426"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout_icon.216ad96e1128280737d51bf10b1836bf.svg";
export { ForwardRef as ReactComponent };